import parseBoolean from './config/parseBoolean';
import { getModelFromInput } from '../../common/getModelFunctions';

export default {
	computed: {
		value() {
			const input_values = this.$el.dataset.inputs.split(',').map(input => {
				return parseBoolean(getModelFromInput(input, this.$model));
			});

			return input_values.reduce((prev, curr) => prev && curr, true);
		}
	},
	listeners: {
		click: true
	}
};
